module.exports = __webpack_public_path__ + "img/pr-3.fb156dab.png";